// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3328":"93e6df18","4637":"35192263"}[chunkId] + ".chunk.css";
};